const getDataByKey = (
  keyword: string,
  props: {
    globalData: DetailTypes.GlobalData;
  }
) => {
  const keys = keyword.split('.');
  const { globalData } = props;
  let value = null as any;
  if (!globalData) return;
  try {
    keys.forEach(item => {
      if (item === void 0) throw new Error('Data undefind!');
      value = value ? value[item] : globalData[item];
    });
  } catch (error) {
    console.warn(`${error}: ${keyword}`);
  }
  return {
    [keys[keys.length - 1]]: value,
  };
};

/**
 *  moduleName: name,
    i18n: globalData.i18n,
    abtest: globalData.abtest,
    devData: devData,
    renderConfig
    这几个属性不需要配置，直接传给每一个组件
 */
const getDataByGlobal = (
  name: string,
  globalDataKeys: string[],
  globalData: DetailTypes.GlobalData,
  renderConfig?: DetailTypes.renderConfig<string>,
  devData?: DetailTypes.devData,
  privateData?: object
) => {
  let params = {
    moduleName: name,
    // 扩展i18n，增加未定义返回key，并异常提示！
    i18n: new Proxy(globalData.i18n, {
      get: (target, prop: string, receiver) => {
        if (!target[prop]) {
          console.warn(`i18n key: ${prop} undefined !`);
          return prop;
        }
        return Reflect.get(target, prop, receiver);
      },
    }),
    abtest: globalData.abtest,
    devData,
    renderConfig,
    ...(privateData && privateData),
  };
  if (!globalData || !globalDataKeys) return params;
  globalDataKeys.forEach((item: string) => {
    params = Object.assign(
      params,
      getDataByKey(item, {
        globalData,
      })
    );
  });
  return params;
};

// 获取组件数据
const getModuleData = (name: string, props: DetailTypes.Root): object | undefined => {
  const { nodeMap, globalData, devData } = props;
  const nodeData = nodeMap[name];
  if (!nodeData) return;
  const { globalDataKeys, renderConfig, privateData } = nodeData;
  return getDataByGlobal(name, globalDataKeys, globalData, renderConfig, devData, privateData);
};

// 支持楼层实验
const getHierarchyByConfig = (
  devData: DetailTypes.devData,
  globalData: DetailTypes.GlobalData,
  hierarchy: DetailTypes.Hierarchy
) => {
  const { abtest } = globalData || {};
  const { hierarchyConfig = {} } = devData || {};
  try {
    Object.keys(hierarchyConfig).map(item => {
      const { value, hierarchyData } = hierarchyConfig[item];
      if (value && hierarchyData && abtest[item] === value) {
        hierarchy.structure = {
          ...hierarchy.structure,
          ...hierarchyData,
        };
      }
    });
  } catch (error) {
    console.warn(`${error}: ${hierarchyConfig}`);
  }
  return hierarchy;
};

// 支持多语言配置
const setI18nDataByConfig = (devData: DetailTypes.devData, globalData: DetailTypes.GlobalData) => {
  const { i18n } = globalData;
  const { i18nConfig = {} } = devData;
  try {
    Object.keys(i18nConfig).map(item => {
      if (i18n[item]) {
        i18nConfig[item].map(config => {
          const { globalDataKeys, value, assignment } = config;
          const keyValue = getDataByKey(globalDataKeys, { globalData });
          if (i18n[assignment] && keyValue && Object.values(keyValue)[0] === value) {
            i18n[item] = i18n[assignment];
          }
        });
      }
    });
  } catch (error) {
    console.warn(`${error}: ${i18nConfig}`);
  }
};

export { getModuleData, getDataByGlobal, setI18nDataByConfig, getHierarchyByConfig };
